<form>
  <mat-form-field appearance="outline" class="full-width mt-3">
    <mat-label>Search Permissions</mat-label>
    <input matInput [formControl]="searchControl" placeholder="Type to search..."/>
  </mat-form-field>
</form>

<div class="permissions-container">
  <div class="permissions-grid">
    <div *ngFor="let permission of filteredPermissions" class="permission-item">
      <mat-checkbox
          [checked]="isPermissionSelected(permission)"
          (change)="togglePermission(permission)"
          [attr.data-testid]="'permission-checkbox-' + permission.Value">
        {{ permission.Name }}
      </mat-checkbox>
    </div>
  </div>
  <p *ngIf="filteredPermissions.length === 0">No permissions found.</p>
</div>
